// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addressBookStyles } from "@eisinc/Overrides/Widgets/Addresses/AddressBook";
import { xScreen } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";

addressBookStyles.gridContainer = { gap: 24 };
addressBookStyles.addressHeaderGridItem = {
    width: 12,
    css: css`
            padding-right: 6px;
        `,
};

addressBookStyles.centeringWrapper = {
    css: css`
            height: 200px;
            width: 100%;
            padding: 15px;
            display: flex;
            align-items: center;
        `,
};
addressBookStyles.spinner = {
    color: "primary.main",
    css: css`
            margin: auto;
        `,
};
addressBookStyles.addressCardGridItem = {
    width: 12,
    css: css`
            padding-left: 0;
            ${xScreen("lte", "sm")} {
                padding-left: 15px;
            }
        `,
};


